export default function getResourceReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_RESOURCE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_RESOURCE_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_RESOURCE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}